// extracted by mini-css-extract-plugin
module.exports = {"modal_content":"WarningFirstPlayer_modal_content__JvtMX"};